import { fromJS } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: action?.hotRefresh === true ? 'FINISHED' : 'IN_PROGRESS',
        items: []
    }));

    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'ERROR',
        errors: fromJS(action.errors)
    }));

    return state.set('collections', collections);
}

export function finish(state, { id, data, index }) {
    let collections = state.get('collections');
    collections = collections.set(id, fromJS({
        state: 'FINISHED',
        items: fromJS(data.map(m => m[index]))
    }));

    return state
        .set('items', fromJS(data))
        .set('collections', collections);
}

export function clear(state, { id }) {
    return state.set(
        'collections',
        state.get('collections').remove(id)
    );
}
